<template>
  <div id="app">
    <router-view/>
    <notifications group="global" position="bottom right"/>
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>

<script>
var head = document.getElementsByTagName( 'head' )[0]

var insertBefore = head.insertBefore

head.insertBefore = function( newElement, referenceElement ) {

    if ( newElement.href && newElement.href.indexOf( 'https://fonts.googleapis.com/css?family=Roboto' ) === 0 ) {
        return
    }

    insertBefore.call( head, newElement, referenceElement )
}
</script>